import { HandleTextChange, HandleCheckChange, RadioHandler, CallAPI, HandleSignatureChange, GetCookieFunction } from '../../utils/util.js';
import React, { Component } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PatientNav } from './patientnav';
import VoiceInput from '../../utils/VoiceInput';
import Alert from 'react-bootstrap/Alert';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        return <Component {...props} router={{ location, navigate, params }} />;
    }
    return ComponentWithRouterProp;
}

// Reusable radio group
const RadioGroup = ({ label, name, options, onChange, required }) => (
    <div className="ci-card">
        <div className="ci-card-label">{label}{required && <span className="ci-required">*</span>}</div>
        <div className="ci-radio-group">
            {options.map((opt, i) => (
                <label key={i} className="ci-radio-option">
                    <input
                        type="radio"
                        id={`${name}${i + 1}`}
                        name={name}
                        value={opt.value}
                        required={required && i === 0}
                        onChange={onChange}
                    />
                    <span>{opt.label}</span>
                </label>
            ))}
        </div>
    </div>
);

class CheckIn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            centerID: GetCookieFunction("Center").id,
            patientID: this.props.router.params.patientId,
            Weight: "", SittingBP: "", StandingBP: "", BodyTemp: "",
            RespiratoryRate: "", Anemia: "", Edema: "", Skin: "",
            Psychic: "", Lungs: "", O2_Saturation: "", Pulse: "",
            Regularity: "", NeckVeins: "", HeartSound: "", AddedSound: "",
            AVF: "", Catheter: "", Infection: false, Signature: "",
            time: 0, Assessment: "", modalVariant: "", modalMessage: "",
            hasDialysisOrder: null, blocked: false,
            dialysisOrder: null, showOrderModal: false
        };
        this.handleTextChange    = HandleTextChange.bind(this);
        this.handleSubmit        = this.handleSubmit.bind(this);
        this.radioHandler        = RadioHandler.bind(this);
        this.handleCheckChange   = HandleCheckChange.bind(this);
        this.handleSignatureChange = HandleSignatureChange.bind(this);
    }

    componentDidMount() {
        CallAPI({}, `patients/${this.state.patientID}/checkinStatus`, 'GET', (res) => {
            if (!res) {
                this.setState({ modalVariant: "danger", modalMessage: "Error loading patient data", blocked: true });
            } else if (!res.patientIdValid) {
                this.setState({ modalVariant: "danger", modalMessage: "Invalid Patient Identifier.", blocked: true });
            } else if (res.checkedIn) {
                this.setState({ modalVariant: "danger", modalMessage: "Patient is already checked-in.", blocked: true });
            }
        });

        // Check if dialysis order exists and has meaningful data
        CallAPI({}, `patients/${this.state.patientID}/dialysisOrder`, 'GET', (res) => {
            // Order is valid only if it was saved by a real doctor (Last_Edited_By > 0)
            if (res && res.Doctor_Fname) {
                this.setState({ hasDialysisOrder: true, dialysisOrder: res });
            } else {
                this.setState({ hasDialysisOrder: false, blocked: true });
            }
        }, () => {
            this.setState({ hasDialysisOrder: false, blocked: true });
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        CallAPI(this.state, "patients/checkin", 'POST',
            (res) => { if (res) this.props.router.navigate(`/patients/${this.state.patientID}/profile`); },
            (message) => this.setState({ modalVariant: "danger", modalMessage: "Failed to check-in patient: " + message.message })
        );
    }

    render = () => {
        const r = (e) => this.radioHandler(e);
        return (
            <div>
                <PatientNav patientId={this.state.patientID} />

                <div className="ci-page">
                    <div className="ci-header">
                        <h2>Patient Check-In</h2>
                        <p>Record pre-treatment vitals and physical assessment</p>
                    </div>

                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} className="ci-alert">
                            {this.state.modalMessage}
                        </Alert>
                    )}

                    {this.state.hasDialysisOrder === false && (
                        <Alert variant="danger" className="ci-alert">
                            This patient does not have a dialysis order on file. A dialysis order must be created before check-in.
                            <div style={{marginTop: '12px'}}>
                                <a href={`/patients/${this.state.patientID}/dialysisorder`} style={{fontWeight: 600, color: 'inherit'}}>
                                    Create Dialysis Order →
                                </a>
                            </div>
                        </Alert>
                    )}

                    {this.state.hasDialysisOrder && (
                        <div style={{marginBottom: '16px'}}>
                            <button type="button" className="homeButton" style={{fontSize: '13px', padding: '8px 16px', minHeight: 'auto'}}
                                onClick={() => this.setState({ showOrderModal: true })}>
                                View Dialysis Order
                            </button>
                        </div>
                    )}

                    {!this.state.blocked && this.state.hasDialysisOrder && (
                    <form onSubmit={(e) => this.handleSubmit(e)}>

                        {/* ── Vitals ── */}
                        <div className="ci-section-title">Vitals</div>
                        <div className="ci-grid">
                            <div className="ci-field">
                                <label htmlFor="weight">Weight (kg)</label>
                                <input type="text" id="weight" name="Weight"
                                    pattern="^\d{1,3}(\.\d{0,2})?$"
                                    title="e.g. 65 or 65.5"
                                    placeholder="e.g. 65.5"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="sittingBP" className="ci-required-label">Sitting BP</label>
                                <input type="text" id="sittingBP" name="SittingBP"
                                    pattern="\d{1,3}\/\d{1,3}" required maxLength="7"
                                    title="e.g. 120/80" placeholder="120/80"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="standingBP">Standing BP</label>
                                <input type="text" id="standingBP" name="StandingBP"
                                    pattern="\d{1,3}\/\d{1,3}" maxLength="7"
                                    title="e.g. 120/80" placeholder="120/80"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="body_temp" className="ci-required-label">Body Temp (°F)</label>
                                <input type="text" id="body_temp" name="BodyTemp"
                                    required pattern="^\d+(\.\d)?$"
                                    title="e.g. 98.6" placeholder="98.6"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="resp_rate" className="ci-required-label">Respiratory Rate</label>
                                <input type="number" id="resp_rate" name="RespiratoryRate"
                                    required placeholder="breaths/min"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="O2_Saturation">O₂ Saturation (%)</label>
                                <input type="number" id="O2_Saturation" name="O2_Saturation"
                                    placeholder="e.g. 98"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="pulse">Pulse Rate (BPM)</label>
                                <input type="number" id="pulse" name="Pulse"
                                    placeholder="e.g. 72"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                        </div>

                        {/* ── Physical Exam ── */}
                        <div className="ci-section-title">Physical Examination</div>

                        <RadioGroup label="Pulse Regularity" name="Regularity" required onChange={r} options={[
                            { value: "regular",   label: "Regular" },
                            { value: "irregular", label: "Irregular" },
                        ]} />

                        <RadioGroup label="Anemia" name="Anemia" required onChange={r} options={[
                            { value: "mild",     label: "Mild" },
                            { value: "moderate", label: "Moderate" },
                            { value: "severe",   label: "Severe" },
                            { value: "absent",   label: "Absent" },
                        ]} />

                        <RadioGroup label="Edema" name="Edema" required onChange={r} options={[
                            { value: "-+",     label: "-+" },
                            { value: "++",     label: "++" },
                            { value: "+++",    label: "+++" },
                            { value: "absent", label: "Absent" },
                        ]} />

                        <RadioGroup label="Skin Condition" name="Skin" required onChange={r} options={[
                            { value: "normal",      label: "Normal" },
                            { value: "warm",        label: "Warm" },
                            { value: "hot",         label: "Hot" },
                            { value: "cool",        label: "Cool" },
                            { value: "dry",         label: "Dry" },
                            { value: "pale",        label: "Pale" },
                            { value: "diaphoretic", label: "Diaphoretic" },
                            { value: "flushed",     label: "Flushed" },
                            { value: "jaundiced",   label: "Jaundiced" },
                            { value: "cyanotic",    label: "Cyanotic" },
                        ]} />

                        <RadioGroup label="Higher Psychic Function" name="Psychic" required onChange={r} options={[
                            { value: "normal",    label: "Normal" },
                            { value: "confused",  label: "Confused" },
                            { value: "lethargic", label: "Lethargic" },
                            { value: "comatose",  label: "Comatose" },
                        ]} />

                        <RadioGroup label="Lung Sound" name="Lungs" required onChange={r} options={[
                            { value: "clear",    label: "Clear" },
                            { value: "crackles", label: "Crackles" },
                            { value: "ronchi",   label: "Ronchi" },
                        ]} />

                        <RadioGroup label="Neck Veins" name="NeckVeins" required onChange={r} options={[
                            { value: "normal",   label: "Normal" },
                            { value: "engorged", label: "Engorged" },
                        ]} />

                        {/* ── Heart Sounds ── */}
                        <div className="ci-card">
                            <div className="ci-card-label ci-required-label">Heart Sound</div>
                            <div className="ci-grid ci-grid-2">
                                <div className="ci-field">
                                    <label htmlFor="heartSound">Heart Sound</label>
                                    <input type="text" id="heartSound" name="HeartSound"
                                        required maxLength="128" placeholder="e.g. S1 S2 normal"
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="addedHeartSound">Additional Heart Sound</label>
                                    <input type="text" id="addedHeartSound" name="AddedSound"
                                        maxLength="128" placeholder="Optional"
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                            </div>
                        </div>

                        <RadioGroup label="AVF" name="AVF" required onChange={r} options={[
                            { value: "none",     label: "None" },
                            { value: "radial",   label: "Radial" },
                            { value: "brachial", label: "Brachial" },
                        ]} />

                        <RadioGroup label="Catheter" name="Catheter" required onChange={r} options={[
                            { value: "none",       label: "None" },
                            { value: "femoral",    label: "Femoral" },
                            { value: "jugular",    label: "Jugular" },
                            { value: "subclavier", label: "Sub Clavier" },
                            { value: "avgraft",    label: "AV Graft" },
                        ]} />

                        {/* ── Assessment ── */}
                        <div className="ci-section-title">Assessment & Signature</div>

                        <div className="ci-card">
                            <div className="ci-field">
                                <label htmlFor="Assessment">Assessment Notes</label>
                                <div className="ci-field-with-voice">
                                    <textarea id="Assessment" name="Assessment" maxLength="500"
                                        rows={3} placeholder="Clinical assessment notes..."
                                        value={this.state.Assessment}
                                        onChange={(e) => this.handleTextChange(e)} />
                                    <VoiceInput language="en" onTranscript={(text) => {
                                        this.setState(prev => ({
                                            Assessment: (prev.Assessment || "") + (prev.Assessment ? " " : "") + text
                                        }));
                                    }} />
                                </div>
                            </div>
                        </div>

                        <div className="ci-card">
                            <label className="ci-checkbox-label">
                                <input type="checkbox"
                                    onChange={(e) => this.handleCheckChange(e)}
                                    value={this.state.Infection}
                                    name="Infection" />
                                <span>Signs / Symptoms of Infection present</span>
                            </label>
                        </div>

                        <div className="ci-card">
                            <label className="ci-checkbox-label ci-signature">
                                <input type="checkbox" required
                                    onChange={(e) => { this.handleCheckChange(e); this.handleSignatureChange(e, this); }}
                                    value="unchecked"
                                    name="Signature" />
                                <span>I confirm the above information is accurate <em>(electronic signature)</em></span>
                            </label>
                        </div>

                        <div className="ci-submit-row">
                            <button type="submit" className="logSubmit ci-submit-btn">
                                Complete Check-In
                            </button>
                        </div>

                    </form>
                    )}

                    {/* Dialysis Order Modal */}
                    {this.state.showOrderModal && this.state.dialysisOrder && (
                        <div className="ci-modal-overlay" onClick={() => this.setState({ showOrderModal: false })}>
                            <div className="ci-modal" onClick={(e) => e.stopPropagation()} style={{maxWidth: '500px', position: 'relative', paddingTop: '24px', paddingLeft: '28px'}}>
                                <button type="button" onClick={() => this.setState({ showOrderModal: false })}
                                    style={{position: 'absolute', top: '12px', right: '12px', background: 'var(--danger)', border: 'none', borderRadius: '50%', width: '36px', height: '36px', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>✕</button>
                                <h3>Dialysis Order</h3>
                                <dl className="profile-dl" style={{margin: '16px 0'}}>
                                    <dt>Frequency</dt><dd>{this.state.dialysisOrder.Frequency} times/week</dd>
                                    <dt>Duration</dt><dd>{this.state.dialysisOrder.Duration} min</dd>
                                    <dt>Blood Flow Rate</dt><dd>{this.state.dialysisOrder.Blood_Flow} mL/min</dd>
                                    <dt>Dry Weight</dt><dd>{this.state.dialysisOrder.Dry_Weight} kg</dd>
                                    <dt>Dialysate Flow</dt><dd>{this.state.dialysisOrder.Dialysate_Flow} mL/min</dd>
                                    <dt>Dialyzer Type</dt><dd>{this.state.dialysisOrder.Dialyzer_Type}</dd>
                                    <dt>Sodium</dt><dd>{this.state.dialysisOrder.Sodium} mEq/L</dd>
                                    <dt>Potassium</dt><dd>{this.state.dialysisOrder.Potassium} mEq/L</dd>
                                    <dt>Calcium</dt><dd>{this.state.dialysisOrder.Calcium} mEq/L</dd>
                                    <dt>Bicarbonate</dt><dd>{this.state.dialysisOrder.Bicarbonate} mEq/L</dd>
                                    {this.state.dialysisOrder.Comments && (
                                        <><dt>Notes</dt><dd>{this.state.dialysisOrder.Comments}</dd></>
                                    )}
                                    <dt>Ordered by</dt><dd>{this.state.dialysisOrder.Doctor_Fname} {this.state.dialysisOrder.Doctor_Lname}</dd>
                                </dl>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    };
}

export default withRouter(CheckIn);
